import React, { useState, useEffect } from "react";
import { Layout, Modal, QRCode, message } from "antd";
import { ShareAltOutlined } from "@ant-design/icons"; // 引入分享图标
import "./detail.scss";
import wx from "weixin-js-sdk";
import axiosInstance from "@/axios/axiosInstance";
import { useLocation } from "react-router-dom"; //useNavigate, Link,
import MyRichTextEditor from "@/assets/MyRichTextEditor";
const IndustrynewsDetail = () => {
  const location = useLocation();
  // let navigate = useNavigate();
  const [IndustrynewsDetail, setIndustrynewsDetail] = useState({
    title: "",
    label: "",
    updateTime: "",
    content: "",
  });
  const [user, setUser] = useState({});
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");
  const [qrVisible, setQrVisible] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  useEffect(() => {
    if (id) {
      fetchDetails(id); // 如果id存在，
      let user = {
        // nickName: nickName,
        // profilePictureUrl: profilePictureUrl,
      };
      setupWechatConfig();
      setUser(user);
    }
  }, [id, nickName, profilePictureUrl]);
  const setupWechatConfig = async () => {
    try {
      const currentUrl = window.location.href.split("#")[0];
      const response = await axiosInstance.get(
        `/account/wxlogin?url=${encodeURIComponent(currentUrl)}`
      );
      const config = response.data.data;
      setCurrentUrl(currentUrl);

      wx.config({
        debug: false, // 开发调试时可以设为 true
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
        ],
      });

      wx.ready(() => {
        // 在wx.ready后立即设置分享内容
        const shareData = {
          title: IndustrynewsDetail.title || "渐风AI", // 使用文章标题
          desc: IndustrynewsDetail.content
            ? IndustrynewsDetail.content.replace(/<[^>]+>/g, "").slice(0, 100) +
              "..."
            : "渐风AI是一个专业的人工智能学习平台", // 使用文章内容的前100字符
          link: currentUrl, // 当前页面链接
          imgUrl: "https://www.aijfeng.com/share-logo.jpg", // 分享图标
          success: function () {
            console.log("分享设置成功");
          },
          fail: function (res) {
            console.error("分享设置失败:", res);
          },
        };
        // 新版接口
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);

        // 旧版接口兼容
        wx.onMenuShareAppMessage({
          ...shareData,
          type: "link",
        });
        wx.onMenuShareTimeline({
          title: shareData.title,
          link: shareData.link,
          imgUrl: shareData.imgUrl,
        });
      });

      wx.error((res) => {
        console.error("微信配置失败:", res);
      });
    } catch (error) {
      console.error("获取微信配置失败:", error);
    }
  };
  // 在文章数据更新后重新设置分享配置
  useEffect(() => {
    if (IndustrynewsDetail.title && currentUrl) {
      setupWechatConfig();
    }
  }, [IndustrynewsDetail, currentUrl]);
  // 处理分享
  useEffect(() => {
    if (IndustrynewsDetail.title) {
      // 更新文档标题
      document.title = `${IndustrynewsDetail.title} - 渐风AI`;

      // 更新 meta 标签
      const metaTags = {
        "og:title": IndustrynewsDetail.title,
        "og:description":
          IndustrynewsDetail.content?.replace(/<[^>]+>/g, "").slice(0, 200) ||
          "",
        "og:url": window.location.href,
      };

      Object.entries(metaTags).forEach(([property, content]) => {
        const meta = document.querySelector(`meta[property="${property}"]`);
        if (meta) {
          meta.setAttribute("content", content);
        }
      });
    }
  }, [IndustrynewsDetail]);
  // 处理分享按钮点击
  const handleShare = () => {
    const shareData = {
      title: IndustrynewsDetail.title,
      desc:
        IndustrynewsDetail.content?.replace(/<[^>]+>/g, "").slice(0, 100) +
        "...",
      link: currentUrl,
      imgUrl: "https://www.aijfeng.com/share-logo.jpg",
    };

    console.log("点击分享按钮，分享数据:", shareData); // 调试用

    wx.ready(() => {
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);
    });

    setQrVisible(true);
  };
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `information/page/detail?informationId=${id}`
      );
      setIndustrynewsDetail(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  // 复制链接到剪贴板
  const copyLink = () => {
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        message.success("链接已复制到剪贴板");
      })
      .catch(() => {
        message.error("复制失败，请手动复制");
      });
  };
  return (
    <Layout className="news_datail">
      <div className="news-hea">
        <div className="name">资讯详情</div>
        <div className="new_content">
          <div className="name_titke"></div>
          <div className="cont_title">
            <div className="title">
              {IndustrynewsDetail.title}
              <ShareAltOutlined
                className="share-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleShare(IndustrynewsDetail);
                }}
              />
            </div>
            <div className="name_time">
              {IndustrynewsDetail.label.split(",").map((label, index) => (
                <span key={index} className="label">
                  {label.trim()}
                </span>
              ))}
            </div>
            <div className="name_time name_footer">
              {user.nickName} <span>{IndustrynewsDetail.updateTime}</span>
              <span>来源为用户上传，如有侵权请申诉</span>
            </div>
          </div>
          <div className="back">
            <img src={IndustrynewsDetail.cover} alt="咨询" />
          </div>
          {/* <div
            dangerouslySetInnerHTML={{ __html: IndustrynewsDetail.content }}
            className="ql-editor"
          ></div> */}
          <div className="ql-editor">
            <MyRichTextEditor value={IndustrynewsDetail.content} />
          </div>
        </div>
      </div>
      <div className="content"></div>
      <Modal
        title="分享到微信"
        open={qrVisible}
        onCancel={() => setQrVisible(false)}
        footer={null}
        className="share-modal"
      >
        <div className="share-content">
          <div className="qr-section">
            <QRCode value={currentUrl} size={200} />
            <p>微信扫码分享</p>
          </div>
          <div className="share-options">
            <div className="share-button" onClick={copyLink}>
              复制链接
            </div>
          </div>
          <div className="share-tips">
            <p>提示：</p>
            <p>1. 使用微信扫描二维码</p>
            <p>2. 点击右上角菜单</p>
            <p>3. 选择"分享给朋友"或"分享到朋友圈"</p>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default IndustrynewsDetail;
